// Google Ads Conversion Tracking
// Multi-conta: Biomo Agência OFICIAL + Thiago Bauer

// ============================================
// CONTA 1: Biomo Agência OFICIAL (3221697754)
// ============================================
export const BIOMO_ADS_ID = 'AW-17657498062'

export const BIOMO_CONVERSIONS = {
  WHATSAPP: {
    id: '7481953182',
    label: 'bUZgCJ6X1u8bEM6T4ONB',
    value: 50,
    name: 'Site Form Biomo - Whatsapp',
  },
  FORM_COMPLETED: {
    id: '7481736478',
    label: 'qVtICJ76yO8bEM6T4ONB',
    value: 100,
    name: 'Site Form Biomo - Formulario Enviado',
  },
  LEAD_REGISTERED: {
    id: '7481735971',
    label: 'A1ezCKP2yO8bEM6T4ONB',
    value: 30,
    name: 'Site Form Biomo - Lead Cadastrado no Sistema',
  },
} as const

// ============================================
// CONTA 2: Thiago Bauer (4025394370)
// ============================================
export const THIAGO_ADS_ID = 'AW-11088474622'

export const THIAGO_CONVERSIONS = {
  WHATSAPP: {
    id: '7482096659',
    label: 'sVMkCJP43u8bEP7jsqcp',
    value: 50,
    name: 'Site Form Biomo - Whatsapp',
  },
  FORM_COMPLETED: {
    id: '7482324225',
    label: 'KTUOCIHq7O8bEP7jsqcp',
    value: 100,
    name: 'Site Form Biomo - Formulario Enviado',
  },
  LEAD_REGISTERED: {
    id: '7482323937',
    label: 'WGvNCOHn7O8bEP7jsqcp',
    value: 30,
    name: 'Site Form Biomo - Lead Cadastrado',
  },
} as const

// ============================================
// CONFIGURAÇÃO MULTI-CONTA
// ============================================
export const GOOGLE_ADS_ACCOUNTS = [
  { id: BIOMO_ADS_ID, conversions: BIOMO_CONVERSIONS, name: 'Biomo Agência' },
  { id: THIAGO_ADS_ID, conversions: THIAGO_CONVERSIONS, name: 'Thiago Bauer' },
] as const

// Compatibilidade
export const GOOGLE_ADS_ID = BIOMO_ADS_ID
export const CONVERSIONS = BIOMO_CONVERSIONS

type ConversionKey = keyof typeof BIOMO_CONVERSIONS

/**
 * Dispara conversão para TODAS as contas Google Ads
 */
export function trackConversion(conversionKey: ConversionKey, customValue?: number) {
  if (typeof window !== 'undefined' && window.gtag) {
    for (const account of GOOGLE_ADS_ACCOUNTS) {
      const conversion = account.conversions[conversionKey]
      window.gtag('event', 'conversion', {
        send_to: `${account.id}/${conversion.label}`,
        value: customValue ?? conversion.value,
        currency: 'BRL',
      })
    }
  }
}

/**
 * Track clique no WhatsApp
 */
export function trackWhatsAppClick() {
  trackConversion('WHATSAPP')
}

/**
 * Track formulário completado
 */
export function trackFormCompleted() {
  trackConversion('FORM_COMPLETED')
}

/**
 * Track lead cadastrado
 */
export function trackLeadRegistered() {
  trackConversion('LEAD_REGISTERED')
}
